import LightGallery from 'lightgallery/react';
import './Gal.css';

// import styles
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-thumbnail.css';
import 'lightgallery/css/lg-autoplay.css';
import 'lightgallery/css/lg-fullscreen.css';
import 'lightgallery/css/lg-share.css';
import 'lightgallery/css/lg-rotate.css';


// import plugins if you need
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';
import lgAutoplay from 'lightgallery/plugins/autoplay'
import lgFullscreen from 'lightgallery/plugins/fullscreen';
import lgShare from 'lightgallery/plugins/share';
import lgRotate from 'lightgallery/plugins/rotate';

const images = [
    { src: "images/Ba21/BA 21 (1).jpg", alt: "1" },
    { src: "images/Ba21/BA 21 (12).jpg", alt: "2" },
    { src: "images/Ba21/BA 21 (11).jpg", alt: "3" },
    { src: "images/Ba21/BA 21 (1).jpg", alt: "4" },
    { src: "images/Ba21/BA 21 (2).jpg", alt: "5" },
    { src: "images/Ba21/BA 21 (3).jpg", alt: "6" },
    { src: "images/Ba21/BA 21 (4).jpg", alt: "7" },
    { src: "images/Ba21/BA 21 (5).jpg", alt: "8" },
    { src: "images/Ba21/BA 21 (6).jpg", alt: "9" },
    { src: "images/Ba21/BA 21 (7).jpg", alt: "10" },
    { src: "images/Ba21/BA 21 (8).jpg", alt: "11" },
    { src: "images/Ba21/BA 21 (9).jpg", alt: "12" },
    { src: "images/Ba21/BA 21 (10).jpg", alt: "13" },
    { src: "images/Ba21/BA 21 (14).jpg", alt: "14" },
    { src: "images/Ba21/BA 21 (15).jpg", alt: "15" },
    { src: "images/Ba21/BA 21 (16).jpg", alt: "16" },
    { src: "images/Ba21/BA 21 (17).jpg", alt: "17" },
    { src: "images/Ba21/BA 21 (18).jpg", alt: "18" },
    { src: "images/Ba21/BA 21 (19).jpg", alt: "19" },
    { src: "images/Ba21/BA 21 (20).jpg", alt: "20" },
    { src: "images/Ba21/BA 21 (21).jpg", alt: "21" },
    { src: "images/Ba21/BA 21 (22).jpg", alt: "22" },
    { src: "images/Ba21/BA 21 (23).jpg", alt: "23" },
    { src: "images/Ba21/BA 21 (24).jpg", alt: "24" },
    { src: "images/Ba21/BA 21 (25).jpg", alt: "25" },
    { src: "images/Ba21/BA 21 (26).jpg", alt: "26" },
]

function Galc21() {
    const onInit = () => {
        console.log('lightGallery has been initialized');
    };
    return (
        <div className="gallery-container">
        <h1>Slab</h1>
       <p className='about'> We specialize in the construction and installation of concrete slabs for various applications. Our expertise ensures strong, level, and durable slabs that provide a solid foundation for any building project
       </p>    <LightGallery
                onInit={onInit}
                speed={500}
                plugins={[lgThumbnail, lgZoom, lgAutoplay, lgFullscreen, lgRotate, lgShare]}
            >

                {images.map((image, index) => {
                    return (
                        <a href={image.src} key={index}>
                            <img alt={image.alt} src={image.src} />
                        </a>
                    )
                })}


            </LightGallery>
        </div>
    );
}
export default Galc21;
